module.exports = __webpack_public_path__ + "img/ata-line.e2bb51a9.png";